import {line} from "d3-shape";
const d3 = {line}

import {STEP, TICK_HEIGHT, SLOT_HEIGHT, SEQUENCE_HEIGHT} from "../mixins/constants";
const D3_LINE = d3.line();

const getBasePairFromPoint = (offsetLayerX, event, fontBoxWidth) => {
    return (event.clientX - offsetLayerX) / fontBoxWidth;
}

const spanPath = (layer, height, start, end, fontBoxWidth) => {
    const path = new LinearShape(layer, fontBoxWidth);
    path.moveTo(start);
    path.lineTo(end);
    path.lineTo(end, height, true);
    path.lineTo(start, 0, false, true);
    return path.toString();
}

const cutPath = (layer, middle, height, cut3, cut5, fontBoxWidth, isSingleStranded = false) => {
    let newline = [
        [0, 0],
    ]
    newline.push([0, middle])
    if (!isSingleStranded) {
        newline.push([(cut3 - cut5) * fontBoxWidth, middle])
        newline.push([(cut3 - cut5) * fontBoxWidth, middle + height])
    }

    return newline;
}

const restrictionEnzymeCut = (restrictionEnzyme, stepLevel, fontBoxWidth,
                                isSlotted, isSingleStranded
                            ) => {
    const { start, cut_5, cut_3, end: rawEnd } = restrictionEnzyme;
    const offset = TICK_HEIGHT + SEQUENCE_HEIGHT + (isSlotted ? SLOT_HEIGHT : 0) - (STEP * 2);
    const selectedAreaHeight = SEQUENCE_HEIGHT + (STEP * 2) + (isSingleStranded ? 0 : SEQUENCE_HEIGHT);
    const cut5_position = 0;

    const cutShape = D3_LINE(
        cutPath(0, offset, SEQUENCE_HEIGHT, cut_3, cut_5, fontBoxWidth, isSingleStranded)
    );

    const selectedArea = spanPath(
        offset - 20,
        selectedAreaHeight,
        start - cut_5,
        rawEnd - cut_5,
        fontBoxWidth
    );

    return [cut5_position, offset, cutShape, selectedArea];
};

const annotationPath = (layer, height, start, end, direction, arrowWidth, fontBoxWidth) => {
    if (direction === 0) {
        return spanPath(layer, height, start, end, fontBoxWidth);
    }

    const path = new LinearShape(layer, fontBoxWidth);
    path.moveTo(start);
    path.lineTo(end);

    (direction === 1) ? path.arrowRight(end, arrowWidth, height, false) : path.lineTo(end, height, true);
    path.lineTo(start)
    direction === 2 || direction === -1 ? path.arrowLeft(start, -arrowWidth, -height, true) : path.closePath()
    return path.toString();
}

const annotationTextPath = (layer, start, end, fontBoxWidth) => {
    const path = new LinearShape(layer, fontBoxWidth);
    path.moveTo(start);
    path.lineTo(end);
    return path.toString();
}

const codonPath = (layer, height, start, end, direction, arrowWidth, fontBoxWidth) => {
    const path = new LinearShape(layer, fontBoxWidth);
    path.moveTo(start);
    path.lineTo(end);
    (direction === 1) ? path.arrowRight(end, arrowWidth, height, false) : path.arrowLeft(end, -arrowWidth, height, false);
    path.lineTo(start)
    direction === 2 || direction === -1 ? path.arrowLeft(start, -arrowWidth, -height, false) : path.arrowRight(start, arrowWidth, -height, false);
    return path.toString();
}

const endCodingSequencePath = (layer, height, position, direction, arrowWidth, fontBoxWidth) => {
    const path = new LinearShape(layer, fontBoxWidth);
    path.moveTo(position);
    if (direction === 1) {
        path.arrowRight(position, arrowWidth, height);
    } else {
        path.arrowLeft(position, -arrowWidth, height);
    }
    return path.toString();
}

const edgeBrushPath = (x, y, height, enableMarker) => {
    let path = `
        M${x},${y}                
        L${x},${y + height}
        `
    if (enableMarker) {
        const radiusMarkerHeight = 10;
        const markerHalfCoordinate1 = y - radiusMarkerHeight;

        path += `L${x},${y}
        A${radiusMarkerHeight / 2},${radiusMarkerHeight / 2},0,0,1,${x},${markerHalfCoordinate1}
        A${radiusMarkerHeight / 2},${radiusMarkerHeight / 2},0,0,1,${x},${y}
        `;
    }
    return path;
}

const LinearShape = class {
    constructor(layer, fontBoxWidth) {
        this.layer = layer;
        this.fontBoxWidth = fontBoxWidth
    }

    moveTo(position) {
        const point = this.point(position)
        this.path = `M
            ${point.x},
            ${point.y}
        `;
    }

    lineTo(position, layer = 0, newLayer = false, close = false) {
        const point = this.point(position, layer)
        this.path += `L
            ${point.x},
            ${point.y}
        `;
        this.layer += newLayer ? layer : 0
        if (close) {
            this.closePath()
        }
    }

    arrowRight(position, arrowLength, height, close = false) {
        this.lineTo(position + arrowLength, (height / 2), true)
        this.lineTo(position, (height / 2), true)

        if (close) {
            this.closePath()
        }
    }

    arrowLeft(position, arrowLength, height = 0, close = false) {
        this.lineTo(position + arrowLength, (height / 2), true);
        this.lineTo(position, (height / 2), true);

        if (close) {
            this.closePath()
        }
    }

    arrow(position, arrowLength, height, close = false) {
        this.lineTo(position + arrowLength, (height / 2), false)
        this.lineTo(position, height, true)
        if (close) {
            this.closePath()
        }
    }

    point(position, layer) {
        const addLayer = layer ? layer : 0;
        return {
            x: position * this.fontBoxWidth,
            y: this.layer + addLayer,
        };
    }

    closePath() {
        this.path += "Z";
    }

    toString() {
        return this.path.replace(/(\r\n|\n|\s|\r)/gm, "");
    }
}

export {
    getBasePairFromPoint,
    spanPath,
    cutPath,
    restrictionEnzymeCut,
    endCodingSequencePath,
    annotationPath,
    annotationTextPath,
    codonPath,
    edgeBrushPath,
    LinearShape
}